export default "__VITE_ASSET__9239e9f7__"